import React from 'react'
import t from 'prop-types'

import { CajaLateral } from 'ibook-api'
import Hito from './hito'

const Camino = ({id, abierta, camino, onHito }) => (
    <CajaLateral id={`caja${id}`} abierta={abierta}>
        { window.modoTrabajo && <div style={{ fontSize: 10, position: 'absolute', backgroundColor: '#ff0', color: '#000' }}>{ camino.libroId + '-' + camino.numPagina }</div> } 
        <div className="contenedorScrollCajaLateral">
            <div className="contenedorHitosCajaLateral">
            { camino.hitos.map ( (hito, index) => <Hito 
                key={`camino-${id}-${index}`} 
                hito={hito} 
                onHito={ () => onHito(camino.libroId, camino.numPagina, index + 1) } 
                /> 
            )}
            </div>
        </div>
    </CajaLateral>
)

Camino.propTypes = {
    id: t.string,
    abierta: t.bool,
    camino: t.object,
    onHito: t.func
}

export default Camino